<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 代理商详情 -->
    <div class="bg-white pdt-10">
      <span class="mgl-10 f16 fw-600 color409eff">代理商详情</span>
      <!-- 代理商信息 -->
      <div class="mgl-20 mgt-20">
        <div class="f16 color1010 mgb-15">代理商信息</div>
        <div class="mgb-15">
          <span class="mgr-100 fw-600">代理商编号：666666</span>
          <span class="mgr-100 fw-600">代理商姓名：李##</span>
          <span class="mgr-100 fw-600">代理商手机号：17777777777</span>
          <span class="mgr-100 fw-600">注册时间：2022-09-09 12：12</span>
        </div>
        <div>
          <span class="mgr-100 fw-600">分润比例：60%</span>
          <span class="mgr-100 fw-600">账号状态：启用</span>
        </div>
      </div>
      <div class="heng mgt-50"></div>
      <div class="pdt-10 pdb-10 flex jcc">
        <el-button @click="eaitagentVisible = true" class="mgr-50"
          >修改代理商信息</el-button
        >
        <el-button @click="eaitratioVisible = true">修改分润比例</el-button>
      </div>
      <!-- 修改代理商信息弹框 -->
      <el-dialog
        title="修改代理商信息"
        :visible.sync="eaitagentVisible"
        :close-on-click-modal="modalFase"
        center
      >
        <el-form
          :model="editagentForm"
          label-position="right"
          label-width="80px"
        >
          <el-form-item label="姓名">
            <el-input v-model="editagentForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="editagentForm.phone" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="mgr-50" @click="eaitagentVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="eaitagentVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 修改分润比例弹框 -->
      <el-dialog
        title="修改分润比例"
        :visible.sync="eaitratioVisible"
        :close-on-click-modal="modalFase"
        center
      >
        <el-form
          :model="editratioForm"
          label-position="right"
          label-width="120px"
        >
          <el-form-item label="当前分润比例">
            <el-input v-model="editratioForm.name" clearable></el-input>%
          </el-form-item>
          <el-form-item label="调节分润比例为">
            <el-input
              v-model="editratioForm.phone"
              placeholder="请输入最新分润比例"
              clearable
            ></el-input
            >%
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="mgr-50" @click="eaitratioVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="eaitratioVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>

    <!-- 账户信息 -->
    <div class="bg-white mgt-10 pdt-10 pdb-20">
      <div class="f16 color1010 mgl-20">账户信息</div>
      <div class="mgl-20 mgt-20">
        <span class="mgr-100 fw-600">总收益：666.66</span>
        <span class="mgr-100 fw-600">累计提现：333.33</span>
        <span class="mgr-100 fw-600">可提现收益：333.33</span>
      </div>
    </div>

    <!-- 设备信息 -->
    <div class="bg-white mgt-10 pdt-10 pdb-20">
      <div class="f16 color1010 mgl-20">设备信息</div>
      <div class="mgl-20 mgt-20 mgb-20">
        <span class="mgr-100 fw-600">设备总数：66</span>
        <span class="mgr-100 fw-600">租赁设备数：33</span>
        <span class="mgr-100 fw-600">购买设备数：33</span>
      </div>
      <!-- 表格 -->
      <el-table
        :data="emqinfotableData"
        border
        stripe
        style="width: 1280px"
        height="200"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="num" label="设备编号" width="300">
        </el-table-column>
        <el-table-column prop="type" label="设备类型" width="300">
        </el-table-column>
        <el-table-column prop="transferdate" label="划拨时间" width="300">
        </el-table-column>
        <el-table-column prop="enddate" label="到期时间" width="300">
        </el-table-column>
      </el-table>
      <!-- 表格下三按钮 -->
      <div class="mgt-20 flex jcc">
        <el-button class="mgr-50">绑定记录查询</el-button>
        <el-button class="mgr-50">绑定</el-button>
        <el-button>解绑</el-button>
      </div>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      modalFase: false,
      emqinfotableData: [
        {
          num: 888888,
          type: "租赁",
          transferdate: "2022-09-09 12:12",
          enddate: "2022-09-09 12:12",
        },
      ], //设备信息数据
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      eaitagentVisible: false, //修改代理商信息弹框是否打开
      editagentForm: {}, //修改代理商信息弹框数据
      eaitratioVisible: false, //修改分润比例弹框是否打开
      editratioForm: {}, //修改分润比例弹框数据
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.heng {
  height: 2px;
  background-color: #e2e2e2;
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

// 表单尺寸
.el-select,
.el-textarea {
  width: 250px;
}
.el-dialog {
  .el-form {
    margin-left: 50%;
    transform: translateX(-50%);
    /deep/ .el-form-item__content {
      display: flex !important;
      width: 300px;
    }
  }
}
</style>
